// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

class CollectionList extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    const game = params.getAll('game_type')
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      game_type: game,
      date: params.get('date'),
      collection_data:[],
      filtered_data:[],
      headers: [],
      search:'',
      loading: false,
      excel_data:[],
      amount_by_sport: {}
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.getAmountBySport = this.getAmountBySport.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    var game_type = this.state.game_type;
    var game_str = '';
    if(game_type.length > 1){
      game_str = `game_type_id=${game_type[0]}&game_type_id=${game_type[1]}`
    }
    else{
      game_str = `game_type_id=${game_type[0]}`
    }
    this.getCustomers(this.state.venue,game_str);
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getCustomers(venue,game_type) {
    var url = ''
    console.log("game_type")
    console.log(game_type)
    // if(game_type == 'game_type_id=0'){
    //    url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=75074&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    // }
    // else if(game_type == 'game_type_id=1001'){
    //   url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=75077&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    // }
    // else if(game_type == 'game_type_id=1002'){
    //   url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=75078&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    // }
    // else{
    //  url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=75073&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    // }


    url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=750748&venue_id=${venue}&${game_type}&date=${this.state.date}`;

    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({collection_data:data.data,headers:data.headers,excel_data:data.excel_data},()=>{
              this.getAmountBySport()
            })
           // alert("fix");
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }
  goBack(){
    this.props.history.goBack();
  }

  getTrProps = (state, rowInfo, instance) => {
      var bgcolor = 'white';
      if(rowInfo && rowInfo.original.includes('row-danger')){
        bgcolor = '#FFC8B8';
      }
      return {
        style: {
          background:bgcolor,
          color:'black'
        }
      };
    };

  getAmountBySport = () => {
    let amountBySport = {}
    let excelData = this.state.excel_data
    let headers= this.state.headers
    let indexOfSport = headers.indexOf('Sport')
    let indexOfPay = headers.indexOf("Total Paid")

    for(let i=0;i<excelData.length;i++) {
      let currentItem = excelData[i]
      if(amountBySport[currentItem[indexOfSport]]) {
        amountBySport[currentItem[indexOfSport]] += currentItem[indexOfPay]
      }
      else {
        amountBySport[currentItem[indexOfSport]] = currentItem[indexOfPay]
      }
    }
    this.setState({
      amount_by_sport: amountBySport
    })
  }

  formatIndianCurrency = (num) => {
    return num.toLocaleString('en-IN')
  };


  renderCutsomers(){
    var excelName = this.state.date +' collection'
    var headers = []
    if(this.state.collection_data.length > 0){
      headers = Object.keys(this.state.collection_data[0])
    }
    
    console.log('renderCutsomers')
    console.log(this.state.excel_data)
    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });


    return(
      <div>
       {
        this.state.amount_by_sport &&
          <div
            style={styles.am_sport_container}
          >
            {
              Object.entries(this.state.amount_by_sport).map(([key, value]) => (
                <div
                  key={key}
                  style={styles.am_sport_card}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1.0)'}
                >
                  <div style={styles.card_title}>
                    {key}
                  </div>
                  <div style={styles.card_value}>
                    {this.formatIndianCurrency(value)}
                  </div>
                </div>
              ))
            }
          </div>
        }


        <div style={{float:'right',marginBottom:'1%'}}>

          <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button btn btn-primary"
                      table="table-to"
                      filename={excelName}
                      sheet={excelName}
                      buttonText="Download as XLS"/>

        </div>
      <div className='col-md-12 table_container1 table-responsive'>
        <div className="heading heading2 left">Collection List </div> 
        { this.state.collection_data.length > 0 ?
          <ReactTable  
                      data={this.state.collection_data}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.collection_data.length > 100}
                      showPaginationTop = {this.state.collection_data.length > 100}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >

          {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#ddd'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }

              </ReactTable>
          :
          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      <table id="table-to" style={{opacity:'0',height:'10%'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each)=>
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
      </table>
    </div>
      )
  }

  render() {
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('collection_data',this.state.collection_data)
    return(
      <div>
        <div>
            
             <div className="breadcrumps" style={{marginBottom:'2%'}}>
                        <a href={'/#/dashboard/ActiveCustomer'} >
                          <span>Dashboard</span>
                        </a> 
                        <a href={'/#/dashboard/CollectionDetails'} >
                          <span>Collection Details </span>
                        </a>
                        <a onClick={() => {this.goBack()}}>
                          <span>Daily Collections</span>
                        </a> 
                        <a >
                          <span>Collection List</span>
                        </a> 
            </div>
          {this.renderCutsomers()}
        </div>
      </div>
    );
  }
}

export default CollectionList;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/collectionList/CollectionList.js